module.exports = __webpack_public_path__ + "static/media/customStep4a.442a813a.png";